import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const SouthwestMap = ({ onStateClick }) => {
	const [selectedState, setSelectedState] = useState(null);
	const [isVisible, setIsVisible] = useState(true);

	const handleStateClick = (area) => {
		setSelectedState(area);
		setIsVisible(false);
		setTimeout(() => {
			onStateClick(area);
		}, 500);
		console.log('State Clicked: %s', area);
	};

	return (
		<svg
			id='southwest-region'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 3000 2200'
			className={`map ${!isVisible ? 'hidden' : ''}`}>
			<polygon
				id='AZ'
				points='960.5 210.5 841.5 1125.5 567.5 1088.5 95.5 818.5 90.5 804.5 103.5 790.5 98.5 781.5 134.5 778.5 153.5 760.5 142.5 743.5 125.5 731.5 126.5 690.5 142.5 663.5 168.5 628.5 174.5 609.5 179.5 587.5 199.5 564.5 226.5 544.5 226.5 527.5 206.5 500.5 201.5 465.5 192.5 444.5 189.5 407.5 204.5 371.5 204.5 256.5 221.5 235.5 242.99 235.5 255.5 247.5 269.5 259.5 284.5 259.5 299.5 239.5 311.5 200.5 317.5 148.5 323.5 109.5 505.5 141.5 845.5 194.5 960.5 210.5'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='AZ'
				className={`polygon ${selectedState === 'AZ' ? 'selected' : ''}`}
				onClick={() => handleStateClick('AZ')}
			/>
			<polygon
				id='NM'
				points='960.5 210.5 841.5 1125.5 957.5 1134.5 966.5 1064.5 1182.5 1084.5 1182.5 1052.59 1669 1091 1728.5 282.5 1520.5 268.5 1236.5 241.5 960.5 210.5'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='NM'
				className={`polygon ${selectedState === 'NM' ? 'selected' : ''}`}
				onClick={() => handleStateClick('NM')}
			/>
			<polygon
				id='OK'
				points='2801.5 302.5 2221.5 302.5 2008.5 295.5 1855.5 292.5 1728.5 282.5 1722.42 365.12 2110 379 2101 696 2149 724 2163 731 2174 726 2185 713 2199 729 2207 752 2255 766 2296 779 2320.01 779 2330 771 2352 771 2356 788 2376 813 2393.19 813 2408 796 2421 803 2437.5 813 2468 817 2477 833 2511 805 2538 805 2553 813 2581 838 2594.55 838 2619 821 2644 812 2734 810 2741 801 2758 811 2791 834 2818 848 2832.5 846.5 2832.5 566.5 2823.5 485.5 2803.5 402.5 2801.5 302.5'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='OK'
				className={`polygon ${selectedState === 'OK' ? 'selected' : ''}`}
				onClick={() => handleStateClick('OK')}
			/>
			<polygon
				id='TX'
				points='1182.5 1084.5 1182.5 1052.59 1669 1091 1722.42 365.12 2110 379 2101 696 2149 724 2163 731 2174 726 2185 713 2199 729 2207 752 2255 766 2296 779 2320.01 779 2330 771 2352 771 2356 788 2376 813 2393.19 813 2408 796 2421 803 2437.5 813 2468 817 2477 833 2511 805 2538 805 2553 813 2581 838 2594.55 838 2619 821 2644 812 2734 810 2741 801 2758 811 2791 834 2818 848 2832.5 846.5 2839.5 855.5 2856.5 859.5 2890.5 860.5 2896.5 946.5 2896.5 1110.5 2917.5 1132.5 2939.5 1178.5 2962.5 1233.5 2971.5 1270.5 2966.5 1297.5 2951.5 1334.5 2953.5 1419.5 2940.5 1445.5 2926.5 1484.5 2882.71 1497.5 2828.5 1518.5 2813.5 1520.5 2803.5 1504.5 2792.5 1497.5 2781.5 1509.85 2781.5 1557.5 2759.5 1582.5 2729.5 1609.5 2687.5 1638.5 2631.5 1672.5 2620.5 1663.5 2599.5 1661.5 2578.5 1669.14 2578.5 1694.5 2540.31 1718.73 2508.5 1745.5 2469.5 1792.5 2451.5 1798.5 2444.5 1821.06 2440.5 1856.5 2415.5 1932.35 2415.5 1955.5 2434.5 2015.5 2444.5 2069.5 2444.5 2112.5 2386.5 2081.5 2357.5 2080.5 2334.5 2069.5 2286.5 2050.5 2229.5 2043.5 2197.5 2013.5 2159.5 1937.5 2138.5 1903.5 2137.5 1838.5 2089.5 1793.5 2079.5 1768.5 2061.5 1729.5 2027.5 1684.5 2003.5 1644.5 1980.5 1593.5 1947.5 1547.5 1919.5 1506.5 1875.5 1478.5 1828.5 1455.5 1766.5 1449.5 1728.5 1461.5 1686.5 1497.5 1649.5 1543.5 1631.5 1579.5 1609.5 1581.5 1534.5 1528.5 1447.5 1460.5 1430.5 1426.5 1411.5 1376.5 1376.5 1292.5 1327.5 1235.5 1281.5 1180.5 1215.5 1106.5 1182.5 1084.5'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='TX'
				className={`polygon ${selectedState === 'TX' ? 'selected' : ''}`}
				onClick={() => handleStateClick('TX')}
			/>
			<rect x='2201.5' y='1321.5' width='147' height='38' fill='none' className='shape' />
			<path
				d='M2248.74,1345.6l-3.86,7.67h-3.14l12.53-24.26h3.53l3.35,24.26h-3.06l-.98-7.67h-8.37ZM2256.89,1343.23l-.94-7.01c-.13-1.26-.31-3.04-.43-4.46h-.08c-.65,1.45-1.25,2.96-1.99,4.42l-3.62,7.05h7.06Z'
				className='shape'
			/>
			<path
				d='M2283.88,1335.87l-2.35,12.34c-.37,1.94-.61,3.62-.78,5.07h-2.69l.45-3.29h-.07c-1.55,2.27-3.84,3.68-6.14,3.68s-4.6-1.08-4.6-5.04c0-.84.11-1.78.33-2.93l1.88-9.83h2.98l-1.85,9.7c-.19.97-.3,1.8-.3,2.55,0,1.8.74,3.03,2.78,3.03,2.18,0,4.95-2.54,5.67-6.36l1.7-8.93h2.98Z'
				className='shape'
			/>
			<path
				d='M2288.86,1350.26c.82.49,2.31,1.09,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.61,0,1.28.84,2.06,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M2312.82,1331.19l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.75Z'
				className='shape'
			/>
			<path
				d='M2319.17,1353.28l3.33-17.41h2.98l-3.33,17.41h-2.98ZM2323.05,1331.01c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.87c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M2330.3,1353.28l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.82,6.46-3.82,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<polygon
				points='2377.75 1356.58 2378.12 1371.5 2393.81 1371.5 2378.34 1380.72 2378.71 1395.65 2368.79 1386.42 2353.33 1395.65 2362.65 1380.72 2352.73 1371.5 2368.42 1371.5 2377.75 1356.58'
				className='shape'
			/>
			<rect x='2432.63' y='557.5' width='335.87' height='49' fill='none' className='shape' />
			<path
				d='M2456.3,580.07c0,4.2-1.54,8.85-4.42,11.72-2.15,2.12-4.97,3.39-8.31,3.39-6.27,0-9.2-4.72-9.2-9.87,0-4.26,1.67-9,4.63-11.89,2.08-2.03,5.08-3.29,8.14-3.29,6.53,0,9.17,4.75,9.17,9.95ZM2441.19,575.07c-2.33,2.34-3.68,6.6-3.68,9.99,0,3.94,1.75,7.59,6.5,7.59,2.07,0,4.03-.89,5.54-2.42,2.29-2.3,3.61-6.65,3.61-10.03s-1.13-7.55-6.43-7.55c-2.15,0-4.05.94-5.54,2.43Z'
				className='shape'
			/>
			<path
				d='M2460.81,594.78l4.86-25.56h2.97l-3.06,16.02h.07c.53-.61,1.17-1.27,1.63-1.75l6.13-6.12h3.69l-7.6,7.15,5.2,10.26h-3.29l-4.19-8.59-2.2,1.97-1.25,6.63h-2.96Z'
				className='shape'
			/>
			<path d='M2480.35,594.78l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M2503.01,594.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM2504.95,579.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M2513.14,594.78l4.86-25.56h2.98l-2.17,11.22h.07c1.49-2.12,3.59-3.46,6.22-3.46,1.98,0,4.33,1.19,4.33,4.66,0,.93-.12,2.06-.29,2.95l-1.94,10.19h-2.98l1.91-10.06c.12-.64.23-1.44.23-2.4,0-1.6-.77-2.86-2.7-2.86-2.31,0-5.2,2.7-5.93,6.6l-1.62,8.72h-2.98Z'
				className='shape'
			/>
			<path
				d='M2551.95,584.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM2538.56,587.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M2556.92,594.78l2.31-12.34c.38-1.94.62-3.62.81-5.07h2.63l-.46,3.27h.08c1.63-2.43,3.82-3.66,6.13-3.66,2.65,0,3.94,1.68,4.07,3.88,1.56-2.52,3.78-3.84,6.4-3.88,2.02,0,4.23,1.29,4.23,4.57,0,.81-.11,1.98-.29,2.96l-1.94,10.28h-2.92l1.88-10.03c.13-.67.25-1.55.25-2.27,0-1.84-.7-3.02-2.62-3.02-2.18,0-4.75,2.5-5.47,6.4l-1.66,8.92h-2.91l1.94-10.22c.15-.78.23-1.45.23-2.13,0-1.47-.41-2.98-2.61-2.98s-4.89,2.88-5.56,6.57l-1.61,8.75h-2.92Z'
				className='shape'
			/>
			<path
				d='M2600.43,594.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM2602.36,579.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M2636.86,594c-1.37.61-3.57,1.16-6.3,1.16-6.11,0-9.85-3.88-9.85-10.07,0-4.57,1.85-8.92,5.18-11.69,2.51-2.12,5.6-3.25,9.14-3.25,2.7,0,4.64.67,5.26,1.17l-.96,2.41c-.9-.54-2.61-1-4.77-1-2.54,0-5.08.98-6.95,2.72-2.28,2.13-3.72,5.55-3.72,9.24,0,4.33,1.99,7.92,7.38,7.92,1.83,0,3.84-.37,5.18-1.04l.4,2.44Z'
				className='shape'
			/>
			<path
				d='M2642.81,594.78l3.33-17.41h2.98l-3.33,17.41h-2.98ZM2646.69,572.51c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.87c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M2661.73,572.69l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.75Z'
				className='shape'
			/>
			<path
				d='M2672.28,577.37l1.72,9.36c.39,2,.61,3.29.79,4.59h.09c.46-1.12.97-2.34,1.85-4.26l4.46-9.69h3.17l-6.54,13.23c-1.87,3.77-3.63,6.83-6,9.16-1.95,1.96-4.07,2.79-5.06,3.01l-.73-2.56c.75-.26,2.01-.75,3.19-1.68,1.18-.91,2.43-2.31,3.37-4.02.15-.29.14-.49.09-.79l-3.49-16.35h3.1Z'
				className='shape'
			/>
			<polygon
				points='2421.88 526.58 2422.25 541.5 2437.94 541.5 2422.48 550.72 2422.85 565.65 2412.92 556.42 2397.46 565.65 2406.79 550.72 2396.86 541.5 2412.55 541.5 2421.88 526.58'
				className='shape'
			/>
			<rect x='479.77' y='716.5' width='183.73' height='36' fill='none' className='shape' />
			<path
				d='M485.44,723.38c1.36-.32,3.3-.52,5.26-.52,2.34,0,4.59.56,5.95,1.87,1.15,1.06,1.76,2.48,1.76,4.39,0,2.71-1.33,4.99-2.91,6.31-1.87,1.58-4.62,2.32-7.35,2.32-.91,0-1.71-.06-2.47-.19l-1.85,9.72h-2.94l4.55-23.9ZM486.14,735.04c.85.18,1.54.24,2.42.24,4.09,0,6.84-2.54,6.84-5.96,0-2.9-2.06-4.04-4.83-4.04-1.18,0-2.08.1-2.61.26l-1.81,9.5Z'
				className='shape'
			/>
			<path
				d='M501.74,747.28l4.86-25.56h2.98l-2.17,11.22h.07c1.49-2.12,3.59-3.46,6.22-3.46,1.98,0,4.33,1.19,4.33,4.66,0,.93-.12,2.06-.29,2.95l-1.94,10.19h-2.98l1.91-10.06c.12-.64.23-1.44.23-2.4,0-1.6-.77-2.86-2.7-2.86-2.31,0-5.2,2.7-5.93,6.6l-1.62,8.72h-2.98Z'
				className='shape'
			/>
			<path
				d='M540.55,736.72c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM527.16,740.41c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M558.18,746.28c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.47,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM554.88,731.8c-2.84,0-4.99,2.78-5.72,5.5,4.69.06,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M564.81,747.28l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.82,6.46-3.82,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M586.91,747.28l3.33-17.41h2.98l-3.33,17.41h-2.98ZM590.79,725.01c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.87c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M602.51,729.87l1.7,3.79c.49,1.12.82,1.98,1.17,2.79h.1c.67-.96,1.06-1.57,1.9-2.63l3.22-3.94h3.45l-7.34,8.47,4.12,8.93h-3.25l-1.75-3.94c-.59-1.3-.85-1.96-1.26-3.1h-.1c-.51.83-1.04,1.65-1.79,2.66l-3.53,4.37h-3.46l7.64-8.96-4.04-8.44h3.24Z'
				className='shape'
			/>
			<polygon
				points='471.01 676.58 471.38 691.5 487.07 691.5 471.61 700.72 471.98 715.65 462.05 706.42 446.59 715.65 455.92 700.72 445.99 691.5 461.68 691.5 471.01 676.58'
				className='shape'
			/>
			<rect x='1346.77' y='425.5' width='193.73' height='38' fill='none' className='shape' />
			<path
				d='M1348.26,453.53c1.32.89,3.14,1.55,5.16,1.55,2.73,0,5.24-1.63,5.24-4.55,0-1.8-1.02-3.15-3.55-4.54-3.1-1.68-4.83-3.62-4.83-6.22,0-4.34,3.73-7.12,8.19-7.12,2.37,0,4.14.69,4.97,1.26l-1.06,2.44c-.76-.46-2.28-1.16-4.21-1.14-3,0-4.8,1.97-4.81,3.96,0,1.97,1.23,3.09,3.77,4.5,2.99,1.6,4.63,3.51,4.63,6.49,0,4.19-3.29,7.5-8.75,7.5-2.43,0-4.82-.79-5.84-1.69l1.08-2.44Z'
				className='shape'
			/>
			<path
				d='M1379.31,457.28c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1381.25,442.1c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M1389.51,457.28l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.82,6.46-3.82,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M1419.41,435.19l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.75Z'
				className='shape'
			/>
			<path
				d='M1437.27,457.28c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1439.21,442.1c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M1461.54,433.02h12.31l-.5,2.55h-9.31l-1.57,8.18h8.58l-.5,2.54h-8.58l-2.08,10.99h-2.98l4.61-24.26Z'
				className='shape'
			/>
			<path
				d='M1487.96,456.28c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.47,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1484.66,441.8c-2.84,0-4.99,2.78-5.72,5.5,4.69.06,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<polygon
				points='1330.01 461.58 1330.38 476.5 1346.07 476.5 1330.61 485.72 1330.98 500.65 1321.05 491.42 1305.59 500.65 1314.92 485.72 1304.99 476.5 1320.68 476.5 1330.01 461.58'
				className='shape'
			/>
			<rect
				x='372.86'
				y='466.02'
				width='266.64'
				height='55.48'
				fill='none'
				className='shape'
			/>
			<path
				d='M384.95,503.97l-7.72,15.35h-6.29l25.07-48.53h7.05l6.71,48.53h-6.12l-1.96-15.35h-16.75ZM401.25,499.21l-1.89-14.02c-.27-2.53-.62-6.09-.86-8.93h-.17c-1.29,2.89-2.5,5.92-3.97,8.84l-7.24,14.11h14.12Z'
				className='shape'
			/>
			<path
				d='M422.06,519.32l4.26-22.43c.85-4.54,1.38-9.16,1.77-12.39h5.26c-.28,2.42-.56,4.85-.97,7.57h.21c2.28-4.77,6-8.36,10.67-8.36.55,0,1.24.04,1.71.13l-1.16,5.89c-.42-.08-.95-.12-1.63-.12-5.17,0-9.77,6.27-11.28,14.35l-2.88,15.36h-5.96Z'
				className='shape'
			/>
			<path
				d='M450.65,519.32l6.65-34.82h5.96l-6.65,34.82h-5.96ZM458.4,474.77c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M469.95,515.64l16.93-18.82c2.95-3.24,4.9-5.03,7.25-7.21l.04-.23h-17.88l.97-4.88h25.02l-.76,3.94-16.69,18.56c-3.12,3.4-4.99,5.24-7.2,7.23l-.02.22h19.32l-.98,4.88h-26.66l.65-3.67Z'
				className='shape'
			/>
			<path
				d='M541.59,498.19c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.31-22.11,9.39,0,13.63,7.1,13.63,14.48ZM514.81,505.58c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M551.52,519.32l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.13h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<path
				d='M618.81,519.32c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM622.69,488.95c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<rect
				x='1106.72'
				y='735.02'
				width='403.78'
				height='55.48'
				fill='none'
				className='shape'
			/>
			<path
				d='M1108.96,788.32l9.23-48.53h6.54l11.12,27.48c2.15,5.52,3.24,9.36,4.26,13.53l.16-.08c.26-4.36.77-8.39,2.03-15.19l4.9-25.75h5.65l-9.23,48.53h-5.9l-11.06-27.43c-2.37-6-3.45-9.4-4.5-14l-.21.08c-.53,4.53-1.31,9.39-2.55,15.99l-4.79,25.37h-5.63Z'
				className='shape'
			/>
			<path
				d='M1185.14,786.33c-2.63,1.48-6.84,2.75-11.51,2.75-9.25,0-13.25-6.3-13.25-14.01,0-10.49,7.79-22.36,19-22.36,6.63,0,10.22,3.95,10.23,8.93,0,9.15-10.31,11.55-23.18,11.31-.29,1.51-.09,4.76.7,6.63,1.4,3.14,4.17,4.68,7.75,4.68,4.14,0,7.25-1.23,9.38-2.39l.88,4.45ZM1178.54,757.36c-5.69,0-9.98,5.55-11.44,11,9.38.11,16.73-1.14,16.73-6.57,0-2.86-2.18-4.44-5.3-4.44Z'
				className='shape'
			/>
			<path
				d='M1206.86,753.5l1.23,19.58c.27,4.31.24,6.54.17,9.37h.16c.83-2.27,2.09-5.26,3.82-8.74l10.36-20.21h5.2l2.2,19.84c.35,3.83.59,6.8.55,9.11h.17c.93-2.81,1.88-5.5,3.29-8.84l9.4-20.11h6.08l-17.21,34.82h-5.55l-2.3-18.92c-.34-3.23-.53-6.2-.51-9.27h-.15c-1.46,3.35-2.46,6-4.04,9.09l-9.99,19.1h-5.58l-3.21-34.82h5.89Z'
				className='shape'
			/>
			<path
				d='M1315,788.32l3.48-26.21c.63-4.63,1.71-11.74,2.63-16.42h-.23c-2.24,4.9-4.95,10.67-7.59,15.64l-14.42,26.69h-4.57l-3.59-26.14c-.74-5.57-1.23-11.21-1.56-16.18h-.16c-1.02,4.48-2.54,11.81-3.7,16.44l-6.6,26.19h-5.62l12.57-48.53h7.62l3.84,27.83c.48,4.12,1.04,8.56,1.17,12.17h.22c1.48-3.61,3.56-7.96,5.65-12l15.02-28h7.81l-6.16,48.53h-5.81Z'
				className='shape'
			/>
			<path
				d='M1361.18,786.33c-2.63,1.48-6.84,2.75-11.51,2.75-9.25,0-13.25-6.3-13.25-14.01,0-10.49,7.79-22.36,19-22.36,6.63,0,10.22,3.95,10.23,8.93,0,9.15-10.31,11.55-23.18,11.31-.29,1.51-.09,4.76.7,6.63,1.4,3.14,4.16,4.68,7.75,4.68,4.14,0,7.25-1.23,9.38-2.39l.88,4.45ZM1354.57,757.36c-5.69,0-9.98,5.55-11.44,11,9.38.11,16.73-1.14,16.73-6.57,0-2.86-2.18-4.44-5.3-4.44Z'
				className='shape'
			/>
			<path
				d='M1383.25,753.5l3.39,7.58c.98,2.25,1.64,3.96,2.33,5.58h.2c1.33-1.92,2.12-3.14,3.8-5.27l6.43-7.89h6.89l-14.68,16.95,8.24,17.87h-6.51l-3.5-7.87c-1.18-2.6-1.7-3.93-2.52-6.2h-.2c-1.02,1.66-2.07,3.29-3.58,5.33l-7.05,8.74h-6.92l15.29-17.93-8.09-16.89h6.48Z'
				className='shape'
			/>
			<path
				d='M1411.8,788.32l6.65-34.82h5.96l-6.65,34.82h-5.96ZM1419.56,743.78c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M1458.01,786.94c-1.78.88-5.38,2.14-10.12,2.14-8.96,0-13.39-6.07-13.39-13.47,0-11.88,8.84-22.89,21.36-22.89,3.25,0,6.18.95,7.24,1.58l-1.71,4.74c-1.38-.66-3.29-1.31-5.92-1.31-9.04,0-14.76,8.92-14.76,17.13,0,5.66,2.96,9.31,8.67,9.31,3.54,0,6.26-1.09,8.05-1.94l.58,4.72Z'
				className='shape'
			/>
			<path
				d='M1503.04,767.19c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.32-22.11,9.39,0,13.63,7.1,13.63,14.48ZM1476.26,774.58c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<rect
				x='1979.72'
				y='1072.02'
				width='192.78'
				height='55.48'
				fill='none'
				className='shape'
			/>
			<path
				d='M1998.59,1081.98h-14.18l1.02-5.19h34.37l-1.01,5.19h-14.25l-8.21,43.34h-5.96l8.21-43.34Z'
				className='shape'
			/>
			<path
				d='M2042.52,1123.33c-2.63,1.48-6.84,2.75-11.51,2.75-9.25,0-13.25-6.3-13.25-14.01,0-10.49,7.79-22.36,19-22.36,6.63,0,10.22,3.95,10.23,8.93,0,9.15-10.31,11.55-23.18,11.31-.29,1.51-.09,4.76.7,6.63,1.4,3.14,4.17,4.68,7.75,4.68,4.14,0,7.25-1.23,9.38-2.39l.88,4.45ZM2035.91,1094.36c-5.69,0-9.98,5.55-11.44,11,9.38.11,16.73-1.14,16.73-6.57,0-2.86-2.18-4.44-5.3-4.44Z'
				className='shape'
			/>
			<path
				d='M2064.59,1090.5l3.39,7.58c.98,2.25,1.64,3.96,2.33,5.58h.2c1.33-1.92,2.12-3.14,3.8-5.27l6.43-7.89h6.89l-14.68,16.95,8.24,17.87h-6.51l-3.5-7.87c-1.18-2.6-1.7-3.93-2.52-6.2h-.2c-1.02,1.66-2.07,3.29-3.58,5.33l-7.05,8.74h-6.92l15.29-17.93-8.09-16.89h6.48Z'
				className='shape'
			/>
			<path
				d='M2115.37,1125.32c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM2119.25,1094.96c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M2136.06,1119.27c1.64.98,4.62,2.17,7.49,2.17,4.02,0,6.63-2.6,6.63-5.69,0-2.72-1.22-4.42-4.84-6.42-4.03-2.23-6.3-5.31-6.3-8.88,0-6.08,5.28-10.74,12.62-10.74,3.16,0,5.94.85,7.25,1.73l-1.68,4.51c-1.2-.7-3.4-1.59-6-1.59-3.64,0-6.21,2.27-6.21,5.23,0,2.56,1.67,4.11,4.79,5.86,3.88,2.19,6.5,5.24,6.5,9.15,0,7.32-5.95,11.48-13.3,11.48-3.75,0-7.08-1.18-8.66-2.39l1.71-4.42Z'
				className='shape'
			/>
			<rect
				x='2299.72'
				y='434.02'
				width='349.78'
				height='55.48'
				fill='none'
				className='shape'
			/>
			<path
				d='M2347.06,457.9c0,8.41-3.08,17.7-8.84,23.44-4.3,4.25-9.94,6.77-16.63,6.77-12.54,0-18.4-9.45-18.4-19.75,0-8.53,3.34-18.01,9.25-23.79,4.16-4.06,10.16-6.58,16.27-6.58,13.06,0,18.35,9.51,18.35,19.9ZM2316.83,447.9c-4.67,4.68-7.37,13.21-7.37,19.99,0,7.89,3.5,15.17,13,15.17,4.13,0,8.06-1.79,11.08-4.85,4.58-4.59,7.23-13.31,7.23-20.07s-2.26-15.11-12.86-15.11c-4.31,0-8.11,1.88-11.09,4.86Z'
				className='shape'
			/>
			<path
				d='M2356.06,487.33l9.72-51.12h5.94l-6.12,32.05h.14c1.06-1.22,2.35-2.55,3.26-3.51l12.27-12.24h7.38l-15.19,14.3,10.4,20.53h-6.57l-8.39-17.19-4.41,3.93-2.5,13.26h-5.92Z'
				className='shape'
			/>
			<path d='M2395.16,487.33l9.75-51.12h5.97l-9.76,51.12h-5.96Z' className='shape' />
			<path
				d='M2440.48,487.33c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.29-1.47,16.14h-5.57ZM2444.36,456.96c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M2460.73,487.33l9.72-51.12h5.97l-4.35,22.44h.14c2.99-4.23,7.19-6.93,12.44-6.93,3.95,0,8.67,2.39,8.67,9.33,0,1.86-.23,4.13-.58,5.89l-3.87,20.39h-5.96l3.82-20.12c.25-1.27.47-2.88.47-4.81,0-3.2-1.54-5.72-5.41-5.72-4.62,0-10.41,5.4-11.86,13.2l-3.25,17.45h-5.96Z'
				className='shape'
			/>
			<path
				d='M2538.36,466.19c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.31-22.11,9.39,0,13.63,7.1,13.63,14.48ZM2511.58,473.58c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.21,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M2548.29,487.33l4.62-24.69c.76-3.87,1.23-7.25,1.61-10.14h5.27l-.92,6.53h.17c3.26-4.86,7.64-7.33,12.27-7.33,5.3,0,7.88,3.37,8.14,7.77,3.12-5.04,7.55-7.69,12.79-7.77,4.03,0,8.46,2.57,8.46,9.13,0,1.61-.22,3.95-.57,5.92l-3.89,20.56h-5.83l3.76-20.06c.25-1.35.51-3.1.51-4.55,0-3.69-1.4-6.05-5.25-6.05-4.36,0-9.5,5.01-10.94,12.81l-3.32,17.85h-5.81l3.89-20.44c.29-1.56.47-2.89.47-4.25,0-2.93-.82-5.97-5.23-5.97s-9.79,5.76-11.12,13.15l-3.22,17.51h-5.83Z'
				className='shape'
			/>
			<path
				d='M2635.31,487.33c-.03-2.1.33-5.39.78-9h-.16c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.29-1.47,16.14h-5.57ZM2639.19,456.96c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
		</svg>
	);
};

SouthwestMap.propTypes = {
	onStateClick: PropTypes.func.isRequired,
	selectedState: PropTypes.string,
};

export default SouthwestMap;
